/* eslint-disable */ 
import React from 'react' ;
import {Dialog as DialogImp} from 'primereact/dialog' ;

export default function Dialog (props){

    return <DialogImp {...props}/>
} 